module.exports = __webpack_public_path__ + "media/images/cropplan 2-cd1888c247db8ea2c1ac2fde1e35f064.png";